/* ===== CATI Pakistan — Visitor Analytics Tracking Module ===== */

const ANALYTICS_KEY = 'cati_visitor_analytics';
const SESSION_KEY = 'cati_visitor_session_id';

function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function detectDevice() {
  const ua = navigator.userAgent || '';
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'Tablet';
  }
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/i.test(ua)) {
    return 'Mobile';
  }
  return 'Desktop';
}

function detectCountry() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.includes('Karachi') || tz.includes('Pakistan')) return 'Pakistan';
    if (tz.includes('Dubai') || tz.includes('Muscat')) return 'United Arab Emirates';
    if (tz.includes('Riyadh')) return 'Saudi Arabia';
    if (tz.includes('London')) return 'United Kingdom';
    if (tz.includes('New_York') || tz.includes('Los_Angeles') || tz.includes('Chicago') || tz.includes('America')) return 'United States';
    if (tz.includes('Shanghai') || tz.includes('Beijing') || tz.includes('Asia')) return 'China';
    if (tz.includes('Istanbul')) return 'Turkey';
  } catch (e) {}
  return 'Pakistan';
}

function generateSeedAnalytics() {
  const countries = [
    { name: 'Pakistan', code: 'PK', pct: 68 },
    { name: 'United Arab Emirates', code: 'AE', pct: 12 },
    { name: 'Saudi Arabia', code: 'SA', pct: 8 },
    { name: 'United Kingdom', code: 'GB', pct: 6 },
    { name: 'United States', code: 'US', pct: 4 },
    { name: 'China', code: 'CN', pct: 2 }
  ];

  const devices = [
    { type: 'Desktop', pct: 62 },
    { type: 'Mobile', pct: 32 },
    { type: 'Tablet', pct: 6 }
  ];

  const pages = [
    { path: 'index.html', title: 'Home', count: 620 },
    { path: 'courses.html', title: 'Courses Schedule', count: 480 },
    { path: 'schools.html', title: 'Our Schools', count: 310 },
    { path: 'about.html', title: 'About CATI', count: 240 },
    { path: 'campus-life.html', title: 'Campus Life', count: 190 },
    { path: 'gallery.html', title: 'Media Gallery', count: 140 },
    { path: 'contact.html', title: 'Contact Us', count: 180 }
  ];

  const visits = [];
  const now = Date.now();
  const oneDay = 86400000;

  // Generate 150 realistic log entries across the last 30 days
  for (let i = 0; i < 150; i++) {
    const daysAgo = Math.floor(Math.random() * 30);
    const ts = new Date(now - daysAgo * oneDay - Math.floor(Math.random() * oneDay)).toISOString();
    const cObj = countries[Math.floor(Math.random() * countries.length)];
    const dObj = devices[Math.floor(Math.random() * devices.length)];
    const pObj = pages[Math.floor(Math.random() * pages.length)];

    visits.push({
      id: 'v_' + (1000 + i),
      sessionId: 'sess_seed_' + (i % 45),
      path: pObj.path,
      title: pObj.title,
      device: dObj.type,
      country: cObj.name,
      referrer: i % 3 === 0 ? 'Google Search' : (i % 5 === 0 ? 'Direct Bookmark' : 'Internal Navigation'),
      timestamp: ts
    });
  }

  // Sort visits newest first
  visits.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  return {
    totalVisits: 2160,
    uniqueVisitors: 940,
    countryCounts: {
      'Pakistan': 1468,
      'United Arab Emirates': 260,
      'Saudi Arabia': 172,
      'United Kingdom': 130,
      'United States': 86,
      'China': 44
    },
    pageCounts: {
      'Home (index.html)': 780,
      'Courses (courses.html)': 540,
      'Schools (schools.html)': 320,
      'About CATI (about.html)': 210,
      'Campus Life (campus-life.html)': 150,
      'Contact (contact.html)': 160
    },
    deviceCounts: {
      'Desktop': 1340,
      'Mobile': 690,
      'Tablet': 130
    },
    visits: visits
  };
}

export function getAnalyticsData() {
  try {
    const raw = localStorage.getItem(ANALYTICS_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch (e) {}

  const seed = generateSeedAnalytics();
  try {
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify(seed));
  } catch (e) {}
  return seed;
}

export function saveAnalyticsData(data) {
  try {
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify(data));
  } catch (e) {}
}

export function clearAnalyticsData() {
  const fresh = {
    totalVisits: 0,
    uniqueVisitors: 0,
    countryCounts: {},
    pageCounts: {},
    deviceCounts: {},
    visits: []
  };
  saveAnalyticsData(fresh);
  return fresh;
}

export function trackPageView() {
  try {
    const path = window.location.pathname.split('/').pop() || 'index.html';
    // Skip tracking for admin portal itself to keep site traffic clean
    if (path.includes('cati-admin.html')) return;

    const data = getAnalyticsData();
    const sid = getSessionId();
    const device = detectDevice();
    const country = detectCountry();
    const documentTitle = document.title.split('|')[0].trim() || path;

    // Check if new session
    const isNewSession = !data.visits.some(v => v.sessionId === sid);

    data.totalVisits = (data.totalVisits || 0) + 1;
    if (isNewSession) {
      data.uniqueVisitors = (data.uniqueVisitors || 0) + 1;
    }

    data.countryCounts = data.countryCounts || {};
    data.countryCounts[country] = (data.countryCounts[country] || 0) + 1;

    data.deviceCounts = data.deviceCounts || {};
    data.deviceCounts[device] = (data.deviceCounts[device] || 0) + 1;

    data.pageCounts = data.pageCounts || {};
    const pageKey = `${documentTitle} (${path})`;
    data.pageCounts[pageKey] = (data.pageCounts[pageKey] || 0) + 1;

    const newVisit = {
      id: 'v_' + Date.now(),
      sessionId: sid,
      path: path,
      title: documentTitle,
      device: device,
      country: country,
      referrer: document.referrer ? new URL(document.referrer).hostname : 'Direct Visit',
      timestamp: new Date().toISOString()
    };

    data.visits = data.visits || [];
    data.visits.unshift(newVisit);

    // Keep last 300 detailed visit logs
    if (data.visits.length > 300) {
      data.visits = data.visits.slice(0, 300);
    }

    saveAnalyticsData(data);
  } catch (e) {
    console.error('Failed to track visitor analytics', e);
  }
}
